import * as monaco from "monaco-editor";
import * as React from "react";

import { Editor } from "lib/components/Editor";
import { getStore } from "../../store";
import { observer } from "mobx-react-lite";

export const App = observer(() => {
  const store = getStore();

  const onChangeQuery = (newValue: string) => {
    store.value = newValue;
  };

  const onEditorDidMount = (
    editor: monaco.editor.IStandaloneCodeEditor,
    monacoModule: typeof monaco,
  ) => {
    if (store.mode !== "json" || store.modeParams == null) {
      return;
    }
    const modeParams = store.modeParams;
    if (modeParams == null) {
      return;
    }
    if (typeof modeParams !== "object") {
      return;
    }
    if (!("json" in modeParams)) {
      return;
    }
    const json = modeParams.json;
    if (json == null) {
      return;
    }
    if (typeof json !== "object") {
      return;
    }
    if (!("schema" in json)) {
      return;
    }
    const schema = json.schema;
    if (schema == null) {
      return;
    }
    const model = editor.getModel();
    if (model == null) {
      return;
    }
    monacoModule.json.jsonDefaults.setDiagnosticsOptions({
      validate: true,
      schemas: [
        {
          uri: "http://json-schema.org/draft-07/schema#",
          fileMatch: [model.uri.toString()],
          schema: schema,
        },
      ],
    });
  };

  return (
    <div>
      <input type="hidden" name={store.inputName} value={store.value} />
      <Editor
        language={store.mode}
        value={store.value}
        readOnly={store.readOnly}
        onChange={onChangeQuery}
        onEditorDidMount={onEditorDidMount}
      />
    </div>
  );
});
